import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { getUrlParam } from 'core-components/helpers/url'

import { getIsOldViewKeptOnLoad } from './planningViewDefault'
import { NEW_VIEW_MODE_URL_PARAM_VALUE, VIEW_MODE_URL_PARAM_KEY } from './viewModeUrlParam'

/** Without `v` in the URL, users get the new view unless they chose to keep the old one; the
 *  default is resolved here rather than by a redirect, so the old view never flashes first. */
export const useViewModeFromUrl = (paramKey = VIEW_MODE_URL_PARAM_KEY): 'old' | 'new' => {
  const location = useLocation()

  return useMemo(() => {
    const viewModeParam = getUrlParam(paramKey, location.pathname)

    if (!viewModeParam) {
      return !getIsOldViewKeptOnLoad() ? 'new' : 'old'
    }

    return viewModeParam === NEW_VIEW_MODE_URL_PARAM_VALUE ? 'new' : 'old'
  }, [location.pathname, paramKey])
}
